import React, { createContext, forwardRef, useContext } from 'react';
import { createPortal } from 'react-dom';
import './inline-feedback.css';

export const PageFeedbackContext = createContext(null);

// Dialogs keep their validation feedback inside the dialog, including portals.
export function LocalFeedbackScope({ children }) {
  return <PageFeedbackContext.Provider value={null}>{children}</PageFeedbackContext.Provider>;
}

/** Page failures always appear below the app header, before metrics and filters. */
export const PageNotice = forwardRef(function PageNotice({ children, className = '', ...props }, ref) {
  const page = useContext(PageFeedbackContext);
  const notice = <div ref={ref} role="alert" {...props} className={`wt-inline-error ${className}`.trim()}>{children}</div>;
  return page?.target ? createPortal(notice, page.target) : notice;
});
